import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button, Icon, Typography } from '@sm/wds-react';
import { t } from '@sm/intl';

import COPY from '../NavBarCopy';
import getNavBarLOLinks from './getNavBarAnonLinks';
import { DesktopScreen } from '../../../..';
import { showBlog } from '../../../../helpers/languageHelpers';
import { SMHeaderContext } from '../../SMHeaderContext';
import { NavSubmenuColumn } from '../../NavSubmenu/NavSubmenuColumn';
import { NavSubmenuByNeed } from '../../NavSubmenu/NavSubmenuByNeed';
import { NavSubmenuBottomLinks } from '../../NavSubmenu/NavSubmenuBottomLinks';
import { getSubmenuTitle } from '../../NavSubmenu/navSubmenuListItems';
import '../../NavSubmenu/nav-submenu.scss';

const NavBarAnon = ({ color }) => {
  const { lang, isEUDC } = useContext(SMHeaderContext);
  const [submenuOpened, setOpen] = useState('');

  const toggleSubmenu = key => {
    if (submenuOpened === key) setOpen('');
    else setOpen(key);
  };

  const navBarAnonLinks = getNavBarLOLinks();

  const linksWithSubmenu = showBlog(lang)
    ? ['Products', 'Resources', 'Solutions']
    : ['Products', 'Solutions'];

  const linksWithoutSubmenu = showBlog(lang)
    ? ['Plans & Pricing']
    : ['Help Center', 'Plans & Pricing'];

  return (
    <DesktopScreen>
      <div className="sm-header__nav--anon">
        {navBarAnonLinks.map(link => {
          const { name, path } = link;

          const linksClassname = classNames(
            `sm-header__nav-cta--${color}`,
            'sm-header__text',
            { 'sm-header--open': submenuOpened === name }
          );

          const submenuClassname = classNames(
            'sm-nav-submenu__container',
            `sm-nav-submenu__${name.toLowerCase()}`,
            'sm-utils--text-align-left',
            { 'sm-nav-submenu--en': lang === 'en' },
            { 'sm-nav-submenu--de': lang === 'de' },
            { 'sm-nav-submenu--fr': lang === 'fr' },
            { 'sm-nav-submenu--locale': lang !== 'en' },
            { 'sm-nav-submenu--open': submenuOpened === name }
          );

          if (linksWithSubmenu.includes(name)) {
            const nameKeyLookup = name.toUpperCase();

            return (
              <div className="wds-display--inline-block" key={name}>
                <Button
                  variant="text"
                  className={linksClassname}
                  color={color}
                  onClick={() => toggleSubmenu(name)}
                >
                  {t(COPY[nameKeyLookup])}
                  <Icon className="sm-header__anon-nav-icon">
                    {submenuOpened === name ? 'Ÿ' : 'á'}
                  </Icon>
                  <Icon className="sm-header__nav-icon-caret">—</Icon>
                </Button>
                <div className={submenuClassname}>
                  {lang !== 'en' && (
                    <Typography
                      variant="sectionTitle"
                      className="sm-nav-submenu__title sm-utils--text-align-center sm-utils--mw-90 sm-utils--mx-auto sm-utils--text-overflow-break"
                    >
                      {getSubmenuTitle(name)}
                    </Typography>
                  )}
                  <NavSubmenuColumn
                    submenuKey={name}
                    lang={lang}
                    isEUDC={isEUDC}
                  />
                  <If condition={lang !== 'en' && name === 'Solutions'}>
                    <NavSubmenuByNeed />
                  </If>
                  <NavSubmenuBottomLinks submenuKey={name} lang={lang} />
                </div>
              </div>
            );
          }
          if (linksWithoutSubmenu.includes(name)) {
            const menuKeyLookup = {
              'Plans & Pricing': 'PLANS_AND_PRICING',
              'Help Center': 'HELP_CENTER'
            }[name];

            return (
              <Button
                key={name}
                variant="text"
                color={color}
                href={path}
                className={`sm-header__nav-cta--${color} sm-header__text`}
              >
                {t(COPY[menuKeyLookup])}
              </Button>
            );
          }
          return null;
        })}
      </div>
    </DesktopScreen>
  );
};

NavBarAnon.propTypes = {
  color: PropTypes.oneOf(['secondary', 'alt'])
};

NavBarAnon.defaultProps = {
  color: 'secondary'
};

export default NavBarAnon;
